import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';

import ContentQRBuilderHeader from '~/components/builder/ContentQRBuilderHeader';
import NameAndOrganizationBlockOldFlow from '~/components/builder/NameAndOrganizationBlockOldFlow';
import PasswordProtectionBlockOldFlow from '~/components/builder/PasswordProtectionBlockOldFlow';
import QrTypeTopCard from '~/components/builder/QrTypeTopCard';
import { SettingsBlock } from '~/components/organisms/editor/SettingsBlock';
import { modelMicrositeService } from '~/components/organisms/previewBar/model-data';
import {
  QR_CODE_BUILDER_CREATED_ID_PARAM_NAME,
  QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME,
  QRCODE_DYNAMIC_MICROSITE_TYPE,
} from '~/constants/qr-code';
import { useAppDispatch } from '~/hooks/useRedux';
import { socialMediaSlice } from '~/store/reducers/previewScreens/social-media';
import { getSocialMediaReducer } from '~/store/reducers/previewScreens/social-media/selectors';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';

import { useQRUrlValidation } from '../../hooks/useQRUrlValidation';

import Appearance from './components/Appearance';
import BasicInformation from './components/BasicInformation';
import Content from './components/Content';

const { actions } = socialMediaSlice;

export default function SocialsTemplate() {
  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();
  const createdId = searchParams.get(QR_CODE_BUILDER_CREATED_ID_PARAM_NAME);
  const isEditPage = !!searchParams.get(QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME);

  const {
    stats: { url, scan, isAutogeneratedUrl, isLimitsEnabled },
  } = useSelector(getSocialMediaReducer);

  const socialMediaReducer = useSelector(getSocialMediaReducer);
  const qrCodeReducer = useSelector(getQrCodeReducerData);

  const urlValidationParams = useQRUrlValidation(url);

  const handleChangeStatsField = (val) => {
    dispatch(actions.setStats(val));
  };

  useEffect(() => {
    if (!createdId || (createdId && !socialMediaReducer.micrositeData?.id)) {
      modelMicrositeService.socialMedia(socialMediaReducer, qrCodeReducer, { dispatch, actions });
    }
  }, []);

  return (
    <Box display="flex" flexDirection="column" flex={1}>
      <ContentQRBuilderHeader />
      <QrTypeTopCard type={QRCODE_DYNAMIC_MICROSITE_TYPE.SOCIAL_MEDIA} />
      <Appearance />
      <BasicInformation />
      <Content />
      <NameAndOrganizationBlockOldFlow onChangeName={(val) => dispatch(actions.setTitle(val))} />
      <PasswordProtectionBlockOldFlow />
      <SettingsBlock
        onChange={handleChangeStatsField}
        urlValidationParams={urlValidationParams}
        scanCount={scan}
        isLimitsEnabled={isLimitsEnabled}
        isAutogeneratedUrl={isAutogeneratedUrl}
        defaultUrlValue={url}
        urlFromBE={qrCodeReducer?.data?.uri || ''}
        isEditPage={isEditPage}
      />
    </Box>
  );
}
